import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ICertinomis} from './certinomis';
import {API_URL, HTTP_OPTION, HTTP_OPTION_PARAMS} from '../app-config.service';


@Injectable({
  providedIn: 'root'
})

export class FinalizeOrderApiService {
  constructor(private readonly http: HttpClient
  ) {

  }




  SendCertificateorder(objOrder: any): Observable<any> {

    // const body = new FormData();
    const body: FormData = new FormData();
    for (const key in objOrder) {
      if (objOrder.hasOwnProperty(key)) {
        body.append(key, JSON.stringify(objOrder[key])); // Convertir les objets ou tableaux en JSON
      }
    }


    return this.http.post<any>(API_URL + '/certificate/order/', body);
  }


}

